import { getConsultationWorklist } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { useIsTcMember } from './use-is-tc-member';
const EMPTY_FILTERS = {
    clinicId: null,
    groupId: null,
    status: [],
    priority: [],
    modality: [],
    species: [],
    bodyArea: [],
    assignedTo: 'all',
    search: '',
    regionId: null,
    unreadOnly: false,
    priorityStatUrgent: false,
    favoritesOnly: false,
    linkOnly: false,
};
const SIDEBAR_WORKLIST_MODE = 'static';
/**
 * Lightweight worklist fetch for global tab counts shown in the app shell sidebar
 * (Studies page, etc.) where TeleconsultationProvider is not mounted.
 */
export function useTeleconsultationSidebarCounts() {
    // Only members of at least one teleconsultation group (and super admins, who
    // are synthesized into every group) can access the worklist. Polling it for
    // anyone else -- every non-TC clinic user -- just produced a 403 roughly once a
    // minute in both regions, so gate the query on the shared entitlement signal.
    const { canAccessTeleconsultation, isLoading: isMembershipLoading } = useIsTcMember();
    return useQuery({
        queryKey: ['teleconsultation-sidebar-counts'],
        queryFn: async () => {
            const tab = 'all';
            return getConsultationWorklist({
                tab,
                filters: EMPTY_FILTERS,
                mode: SIDEBAR_WORKLIST_MODE,
                page: 1,
                pageSize: 1,
                sortBy: 'submittedAt',
                sortDir: 'desc',
            });
        },
        enabled: !isMembershipLoading && canAccessTeleconsultation,
        staleTime: 30_000,
        refetchInterval: () => 55_000 + Math.random() * 10_000,
        retry: 1,
    });
}
